import { useEffect, useRef } from 'react'

// ※ React Router v6
import { Location, useLocation } from 'react-router-dom'

/**
 * ページ遷移時処理フック
 * ページ遷移時に行いたい処理をコールバックとして渡す。
 * 
 * 参考：https://koredana.info/blog/reactjs-client-routing-change-event/
 *
 * @param {(location: Location) => void} callback
 */
const useLocationChange = (callback: (location: Location) => void) => {
    const refCallback = useRef<undefined | ((location: Location) => void)>()
    const location = useLocation()

    useEffect(() => {
        refCallback.current = callback
    }, [callback])

    // ロケーションに変更があったときに処理実行
    useEffect(() => {
        if (refCallback.current) {
            refCallback.current(location)
        }
    }, [location])
}

export default useLocationChange;